import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// Webpack alias resolved at build time (same pattern as other sidebars).
// eslint-disable-next-line import/no-unresolved
import isotipo from 'images/isotipo.svg';
import IconMC from '../../components/IconMC';
import {
  MARKETING_GLOBAL_ROUTES,
  MARKETING_HOME_PATH,
  isMarketingCampaignsPath,
  isMarketingIntegrationsPath
} from '../../modules/Marketing/constants/MarketingNavConstants';

const MarketingGlobalSidebarMC = () => {
  const location = useLocation();
  const { t } = useTranslation('Routes');

  const isRouteActive = (key, urlLinkPath) => {
    if (key === 'campaigns') return isMarketingCampaignsPath(location.pathname);
    if (key === 'integrations') return isMarketingIntegrationsPath(location.pathname);
    return location.pathname === urlLinkPath;
  };

  return (
    <div
      id="marketing-sidebar-pc-wrapper-react"
      className="tw-fixed tw-left-0 tw-top-0 tw-z-40 tw-hidden tw-h-full md:tw-block"
    >
      <section id="marketing-sidebar--pc-react" className="tw-hidden md:tw-block">
        <div id="marketing-sidebar__logo--pc" className="tw-flex tw-items-center tw-justify-center tw-p-8">
          <Link to={MARKETING_HOME_PATH} className="item__name no-style">
            <img src={isotipo} alt="Mercately" />
          </Link>
        </div>
        <div id="marketing-sidebar__menu--pc">
          <ul className="menu no-style">
            {MARKETING_GLOBAL_ROUTES.map(({ icon, useCssIcon, routeProps }) => {
              const isActive = isRouteActive(routeProps.key, routeProps.urlLinkPath);
              return (
                <li key={routeProps.key} className="menu__item">
                  <div className={`merc-tooltip ${isActive ? 'merc-tooltip-active' : ''}`}>
                    <Link to={routeProps.urlLinkPath} className="item__name no-style">
                      {useCssIcon ? (
                        <i className={icon} />
                      ) : (
                        <IconMC name={icon} className="tw-size-5" />
                      )}
                    </Link>
                    <div className="merc-tooltiptext">{t(routeProps.i18nTitleKey)}</div>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </section>
    </div>
  );
};

export default MarketingGlobalSidebarMC;
